/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, ErrorMessage, SwitchInput, UploadImageCard } from "@";
import CertificateCardDesign from "../CertificateCardDesign";
import { EndowmentCertificateDesignSectionProps } from "./types";

export const EndowmentCertificateDesignSection = ({
  watch,
  setValue,
  getValues,
  errors,
  show,
  isSubmitSuccessful,
  handleUploadCertificate,
  isShowCertificateImageDesigner,
  saveCertificateImageDesign,
  closeCertificateImageDesigner,
  certificateImageDesign,
  showCertificateImageDesigner,
}: EndowmentCertificateDesignSectionProps) => {
  return (
    <Card
      className="lg:col-span-2"
      isOpen={watch("haveCertificate") || false}
      title="الشهادة الوقفية"
    >
      <SwitchInput
        label="عمل شهادة وقفية"
        disabled={!!show}
        checked={watch("haveCertificate") as boolean}
        change={(value: boolean) => setValue("haveCertificate", value)}
      />

      {/* Certificate */}
      {watch("haveCertificate") && (
        <div className="mt-4">
          {isShowCertificateImageDesigner && (
            <CertificateCardDesign
              save={saveCertificateImageDesign}
              url={
                (watch("certificateView") ||
                  getValues("certificateUrl")) as string
              }
              close={closeCertificateImageDesigner}
              design={certificateImageDesign}
              title="تصميم الشهادة الوقفية"
            />
          )}

          <UploadImageCard
            show={!show}
            success={isSubmitSuccessful}
            title="صورة الشهادة الوقفية"
            star={!getValues("certificateUrl")}
            error={(errors.certificate as { message?: string })?.message}
            upload={handleUploadCertificate}
            src={
              (watch("certificateView") ||
                getValues("certificateUrl")) as string
            }
          />

          {((watch("certificateView") as string) ||
            (getValues("certificateUrl") as string)) &&
            !show && (
              <p
                onClick={() => showCertificateImageDesigner()}
                className="cursor-pointer rounded-2xl border border-gray-200 p-1.5 text-sm hover:border-green-500 hover:bg-green-100 dark:border-gray-600"
              >
                اضغط هنا لتصميم الشهادة الوقفية
              </p>
            )}
        </div>
      )}
      <ErrorMessage
        value={(errors.Certificate as { message?: string })?.message}
      />
    </Card>
  );
};
